<template>
  <base-page
    :title="'Create Users'"
  >
    <template #main>
      <user-create-update-form />
    </template>
  </base-page>
</template>
<script>
import { mapActions } from 'vuex'
import UserCreateUpdateForm from '@/components/User/UserCreateUpdateForm'
import BasePage from "../BasePage"

export default {
  components: {
    BasePage,
    UserCreateUpdateForm
  },
  created() {
    this.initUsers()
  },
  methods: {
    ...mapActions([ 'initUsers' ])
  },
}
</script>
